<template>
  <ThePage :title="i18n(translations.title)">
    <template #pageTitle>
      {{ i18n(translations.title) }}
    </template>
    <template #pageContent>
      <NavTabs
        :index-route-name="ROUTE_NAMES.BUYBACK.ORDERS.INDEX"
        :label="translations.title"
      />
    </template>
  </ThePage>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './Orders.translations'

const i18n = useI18n()
</script>
